import {
  Container,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
} from "@mui/material";

import { CardElement } from "@stripe/react-stripe-js";

const Card = (props) => {
  return (
    <CardElement
      options={{
        style: {
          base: {
            // iconColor: "#fff",
            // color: "#fff",
            fontWeight: 400,
            fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",

            "::placeholder": {
              // color: "#BFAEF6"
            },
            ":-webkit-autofill": {
              // color: "#fce883"
            },
          },
          invalid: {
            iconColor: "#FFC7EE",
            color: "#FFC7EE",
          },
        },
      }}
    />
  );
};

export default Card;
